// Bubble colors designed for dark background (#1a1a2e)
// All pairings tested for WCAG AA contrast ratio (4.5:1 minimum)
export const languageConfig = {
    'Mandarin': {
        messageColor: 'yellow-gradient',
        color: '#c2402a',          // deep red
        textColor: '#FFFFFF',
        loc: 'zh-CN',
        input: 'text'
    },
    'Cantonese': {
        messageColor: 'yellow-gradient',
        color: '#b5651d',          // burnt orange
        textColor: '#FFFFFF',
        loc: 'zh-HK',
        input: 'text'
    },
    'Spanish': {
        messageColor: 'red-gradient',
        color: '#c7393b',          // Spanish red
        textColor: '#FFFFFF',
        loc: 'es',
        input: 'latin-prose'
    },
    'English': {
        messageColor: 'blue-gradient',
        color: '#4a6fa5',          // steel blue
        textColor: '#FFFFFF',
        loc: 'en',
        input: 'latin-prose'
    },
    'Hindi': {
        messageColor: 'orange-gradient',
        color: '#d17a22',          // warm amber
        textColor: '#FFFFFF',
        loc: 'hi',
        input: 'text'
    },
    'Bengali': {
        messageColor: 'green-gradient',
        color: '#2e7d32',          // forest green
        textColor: '#FFFFFF',
        loc: 'bn',
        input: 'text'
    },
    'Portuguese': {
        messageColor: 'light-green-gradient',
        color: '#1b8a5a',          // emerald
        textColor: '#FFFFFF',
        loc: 'pt',
        input: 'latin-prose'
    },
    'Russian': {
        messageColor: 'dark-blue-gradient',
        color: '#5b4a9e',          // deep purple
        textColor: '#FFFFFF',
        loc: 'ru',
        input: 'text'
    },
    'Japanese': {
        messageColor: 'dark-red-gradient',
        color: '#a83256',          // crimson rose
        textColor: '#FFFFFF',
        loc: 'ja',
        input: 'kana'
    },
    'Korean': {
        messageColor: 'dark-red-gradient',
        color: '#3b5daa',          // royal blue
        textColor: '#FFFFFF',
        loc: 'ko',
        input: 'hangul'
    },
    'Punjabi': {
        messageColor: 'pink-gradient',
        color: '#8b3a8b',          // plum
        textColor: '#FFFFFF',
        loc: 'pa',
        input: 'text'
    },
    'German': {
        messageColor: 'black-gradient',
        color: '#555555',          // charcoal
        textColor: '#FFFFFF',
        loc: 'de',
        input: 'latin-prose'
    },
    'French': {
        messageColor: 'blue-white-red-gradient',
        color: '#2d5f8a',          // French blue
        textColor: '#FFFFFF',
        loc: 'fr',
        input: 'latin-prose'
    },
    'Thai': {
        messageColor: 'red-white-blue-gradient',
        color: '#9b2335',          // Thai red
        textColor: '#FFFFFF',
        loc: 'th',
        input: 'text'
    },
    'Dutch': {
        messageColor: 'orange-white-gradient',
        color: '#cc6e2f',          // Dutch orange
        textColor: '#FFFFFF',
        loc: 'nl',
        input: 'latin-prose'
    },
    'Hebrew': {
        messageColor: 'blue-white-star-gradient',
        color: '#336699',          // muted blue
        textColor: '#FFFFFF',
        loc: 'he',
        input: 'text'
    },
    'Filipino': {
        messageColor: 'blue-red-yellow-gradient',
        color: '#2b6e9e',          // ocean blue
        textColor: '#FFFFFF',
        loc: 'fil',
        input: 'latin-prose'
    },
    'Hungarian': {
        messageColor: 'purple-gradient',
        color: '#7b4baa',          // violet
        textColor: '#FFFFFF',
        loc: 'hu',
        input: 'latin-prose'
    },
};
